import type { ReactNode } from "react";
import {
  LOCALIZED_ICON_TYPE,
  type LocalizedIconType,
} from "@/shared/types/localized-icon";
import { BackArrowIcon } from "@/shared/ui/icons/back-arrow-icon";
import { ChevronLeftIcon } from "@/shared/ui/icons/chevron-left-icon";
import { ChevronRightIcon } from "@/shared/ui/icons/chevron-right-icon";
import { ForwardArrowIcon } from "@/shared/ui/icons/forward-arrow-icon";

export function createLocalizedIcon(
  rtl: boolean,
): (iconType: LocalizedIconType) => ReactNode {
  return (iconType: LocalizedIconType): ReactNode => {
    if (iconType === LOCALIZED_ICON_TYPE.CHEVRON_FORWARD) {
      return rtl ? <ChevronLeftIcon /> : <ChevronRightIcon />;
    }

    if (iconType === LOCALIZED_ICON_TYPE.ARROW_BACK) {
      return rtl ? <ForwardArrowIcon /> : <BackArrowIcon />;
    }

    return <span>?</span>;
  };
}
